import styled from 'styled-components'

// Components
import Modal from 'components/Modal'
import { Select } from 'components/Select'
import { NativeSelectWrapper } from 'components/Select/NativeSelect.styles'
import { Text, Form, inputBorderStyle } from '@sketch/components'

export const CheckboxGroup = styled.div`
  & ${Form.Field} {
    margin-bottom: 16px;
  }
  margin-top: 16px;
`

export const StyledModal = styled(Modal)`
  & ${Modal.Body} {
    &:first-child {
      margin-top: 0;
    }
  }
`

export const StyledSelect = styled(Select)`
  min-width: 164px;
  margin-right: 16px;
`

export const HumanReadableExpiry = styled(Text.Div).attrs({
  textStyle: 'copy.quaternary.standard.C',
})`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const ExpiryInputContainer = styled.div`
  display: flex;
  flex-direction: row;

  & input[type='date'] {
    min-width: 134px;
    color: ${({ theme }) => theme.colors.foreground.secondary.D};

    ${inputBorderStyle}
  }

  & ${NativeSelectWrapper} {
    min-width: 164px;
    margin-right: 16px;
  }
`
